import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { isDashboardConversationsRoute } from '../../routing/routes';
import { findConversations } from '../../services/api/miles/notes';
import { setConversations } from '../../services/redux/features/notificationCenter.slice';

export const useFetchNotifications = (pathname: string) => {
  const dispatch = useDispatch();
  const isRequestLoadingRef = useRef(false);

  useEffect(() => {
    if (!pathname.startsWith('/dashboard') || isDashboardConversationsRoute()) return;
    if (isRequestLoadingRef.current) return;

    isRequestLoadingRef.current = true;

    findConversations({ statuses: ['OPEN'] })
      .then((response) => {
        dispatch(setConversations(response.conversations ?? []));
      })
      .finally(() => {
        isRequestLoadingRef.current = false;
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
};
